var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    stroke: "currentColor",
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Exit"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    stroke: "currentColor",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.9803 5.98053C15.2732 5.68763 15.2732 5.21276 14.9803 4.91987C14.6874 4.62697 14.2125 4.62697 13.9196 4.91987L9.94995 8.88954L5.98028 4.91987C5.68739 4.62697 5.21251 4.62697 4.91962 4.91987C4.62673 5.21276 4.62673 5.68763 4.91962 5.98053L8.88929 9.9502L4.91962 13.9199C4.62673 14.2128 4.62673 14.6876 4.91962 14.9805C5.21251 15.2734 5.68739 15.2734 5.98028 14.9805L9.94995 11.0109L13.9196 14.9805C14.2125 15.2734 14.6874 15.2734 14.9803 14.9805C15.2732 14.6876 15.2732 14.2128 14.9803 13.9199L11.0106 9.9502L14.9803 5.98053Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExit);
export default __webpack_public_path__ + "static/media/exit.cd64a6879779477c03c8acd6c22254b1.svg";
export { ForwardRef as ReactComponent };